import React, { useState } from "react";
import kamlaLogo from '../assests/kamlaLogo.png'; 
import '../styles/main.css'; 

// --- Utilities ---

function numberToWords(num) {
  if (num == null) return "-";
  num = Number(num);
  if (isNaN(num)) return "-";

  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const scales = ['', 'Thousand', 'Lakh', 'Crore'];

  function chunkToWords(n) {
    let word = "";
    if (n > 99) {
      word += ones[Math.floor(n / 100)] + " Hundred";
      n = n % 100;
      if (n) word += " and ";
    }
    if (n < 20) {
      word += ones[n];
    } else {
      word += tens[Math.floor(n / 10)];
      if (n % 10) word += " " + ones[n % 10];
    }
    return word;
  }
  function splitIndianNumber(n) {
    const str = n.toString();
    let chunks = [];
    let end = str.length;
    chunks.push(parseInt(str.substring(Math.max(0, end - 3), end), 10));
    end -= 3;
    while (end > 0) {
      let start = Math.max(0, end - 2);
      chunks.push(parseInt(str.substring(start, end), 10));
      end -= 2;
    }
    return chunks;
  }

  if (num === 0) return "Zero";
  const numberChunks = splitIndianNumber(parseInt(num));
  let wordArray = [];
  for (let i = 0; i < numberChunks.length; i++) {
    if (numberChunks[i] > 0) {
      wordArray.push(chunkToWords(numberChunks[i]) + (scales[i] ? " " + scales[i] : ""));
    }
  }
  return wordArray.reverse().join(" ").trim();
}

function formatDateToDDMMYYYY(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = ("0" + d.getDate()).slice(-2);
  const month = ("0" + (d.getMonth() + 1)).slice(-2);
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

const formatIndianTime = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toLocaleTimeString("en-IN", {
        hour: "2-digit", 
        minute: "2-digit",
        hour12: true
      });
    }
  } catch (e) {
    return "";
  }
  return "";
};

// --- Main Component ---

const PaymentReceipt = ({ show, hospital, customer, payment, onClose, onPrint }) => {
  const [showHeader, setShowHeader] = useState(true);

  if (!show || !hospital || !customer || !payment) return null;

  const handlePrint = () => {
    if (onPrint) onPrint();
    else window.print();
  };

  const handleToggleHeader = () => {
    setShowHeader(!showHeader);
  };

  const payDate = payment.payDate || payment.PayDate || new Date();
  const receiptDateStr = formatDateToDDMMYYYY(payDate);
  const receiptTimeStr = formatIndianTime(payDate);

  const receivedAmount = Number(payment.received) || 0;
  const cashAmount = Number(payment.cash) || 0;
  const upiAmount = Number(payment.upi) || 0;

  // Create items list for the table
  const items = [];
  let srNo = 1;
  if (cashAmount > 0) {
    items.push({ sr: srNo++, desc: "Cash Payment", amount: cashAmount });
  }
  if (upiAmount > 0) {
    items.push({ sr: srNo++, desc: "UPI / Online Transfer", amount: upiAmount });
  }

  return (
    <>
      {/* =========================================
         INLINE CSS: PRINT & MARG BILLING STYLES
      ========================================= */}
      <style>{`
        :root {
          --marg-border: 1px solid #000;
          --marg-border-thick: 2px solid #000;
          --marg-font: Arial, Helvetica, sans-serif;
        }

        .marg-receipt-wrapper {
          font-family: var(--marg-font);
          color: #000;
          background: #fff;
          font-size: 11px; 
        }

        .marg-outer-box {
          border: var(--marg-border-thick);
          margin-bottom: 10px;
          height: 110mm; /* रसीद की कुल ऊंचाई कम कर दी गई है */
          width: 100%;
          box-sizing: border-box;
          position: relative;
          background: #fff;
          display: flex;
          flex-direction: column;
          page-break-inside: avoid;
        }

        .marg-header {
          border-bottom: var(--marg-border-thick);
          padding: 4px 10px; 
          text-align: center;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .marg-title-strip {
          background-color: #e0e0e0 !important; 
          border-bottom: var(--marg-border-thick);
          text-align: center;
          padding: 2px; 
          font-weight: 900;
          font-size: 12px;
          letter-spacing: 1px;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .marg-patient-box {
          display: flex;
          border-bottom: var(--marg-border-thick);
        }

        .marg-patient-col { padding: 2px 8px; } 
        .marg-patient-left { width: 55%; border-right: var(--marg-border-thick); }
        .marg-patient-right { width: 45%; }

        .marg-patient-col table {
          width: 100%;
          font-size: 11px;
          line-height: 1.3; 
        }
        .marg-patient-col table td { vertical-align: top; padding: 1px 0;}

        /* Items Table */
        .marg-table-container {
          height: 22mm; /* केवल 3 सर्विसेज के लिए जगह */
          display: flex;
          flex-direction: column;
        }

        .marg-table-header {
          display: flex;
          border-bottom: var(--marg-border);
          font-weight: bold;
          text-transform: uppercase;
          font-size: 10px;
          background-color: #e0e0e0 !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .marg-table-row {
          display: flex;
          font-size: 11px;
        }

        .marg-table-filler {
          flex-grow: 1;
          display: flex;
          align-items: stretch;
        }

        .marg-col-sr { width: 10%; text-align: center; padding: 2px 5px; border-right: var(--marg-border); }
        .marg-col-desc { width: 65%; text-align: left; padding: 2px 5px; border-right: var(--marg-border); }
        .marg-col-amt { width: 25%; text-align: right; padding: 2px 5px; }

        /* Footer Sections */
        .marg-footer-grid {
          display: flex;
          border-top: var(--marg-border-thick);
        }

        .marg-words-box {
          width: 55%;
          border-right: var(--marg-border-thick);
          padding: 6px 8px; 
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .marg-calc-box { width: 45%; }
        .marg-calc-table { width: 100%; border-collapse: collapse; height: 100%; }
        .marg-calc-table td { padding: 4px 8px; border-bottom: var(--marg-border); font-size: 11px; }
        .marg-calc-table tr:last-child td { border-bottom: none; }

        .marg-highlight-row td {
          background-color: #e0e0e0 !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .marg-signature-box {
          display: flex;
          justify-content: space-between;
          padding: 15px 15px 5px 15px; 
          border-top: var(--marg-border-thick);
          background: #fff;
        }

        .marg-sig-line {
          border-top: 1px solid #000;
          padding-top: 3px;
          text-align: center;
          font-weight: bold;
          font-size: 10px;
          width: 100%;
        }

        /* =========================================
           PRINT MEDIA QUERIES
        ========================================= */
        @media print {
          @page { 
            size: A4 portrait; 
            margin: 2mm 5mm 5mm 5mm; 
          }
          html, body {
            height: 100% !important;
            overflow: hidden !important; 
            background: white !important;
            margin: 0 !important;
            padding: 0 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          body * { visibility: hidden; }
          #marg-print-section, #marg-print-section * { visibility: visible; }
          
          #marg-print-section {
            position: absolute !important;
            left: 0 !important; 
            top: 0 !important; 
            width: 100% !important; 
            margin: 0 !important; 
            padding: 0 !important;
          }

          .modal, .modal-dialog, .modal-content, .modal-body {
            border: none !important; 
            box-shadow: none !important;
            background: transparent !important; 
            padding: 0 !important;
            margin: 0 !important;
            position: static !important;
            transform: none !important;
          }
          
          .marg-outer-box {
            margin-top: 0 !important; 
            margin-bottom: 0 !important;
          }

          .no-print { display: none !important; }
        }
      `}</style>

      <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }}>
        <div className="modal-dialog" style={{ maxWidth: '750px', margin: '20px auto' }}>
          <div className="modal-content border-0 bg-transparent">
            
            <div id="marg-print-section" className="marg-receipt-wrapper p-2 bg-white rounded">
              
              <div className="marg-outer-box">
                
                {/* --- Header --- */}
                {showHeader ? (
                  <div className="marg-header">
                    <div style={{ width: '70px', height: '70px' }}>
                      {kamlaLogo && (
                        <img 
                          src={kamlaLogo} 
                          alt="Logo" 
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                        />
                      )}
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <h2 style={{ margin: '0 0 3px 0', fontWeight: '900', fontSize: '18px', textTransform: 'uppercase' }}>
                        {hospital.company_Name}
                      </h2>
                      <p style={{ margin: '0', fontSize: '11px' }}>{hospital.address}</p>
                      <p style={{ margin: '2px 0 0 0', fontSize: '11px' }}>
                        <strong>Ph:</strong> {hospital.contact1} &nbsp;|&nbsp; <strong>Email:</strong> {hospital.email_ID}
                      </p>
                    </div>
                    <div style={{ width: '80px', textAlign: 'right', fontSize: '10px' }}>
                      <strong>Reg No:</strong><br/>{hospital.reg_No || 'N/A'}
                    </div>
                  </div>
                ) : (
                  <div style={{ height: "80px" }}></div>
                )}

                <div className="marg-title-strip">
                  PAYMENT RECEIPT
                </div>

                {/* --- Patient Info Box --- */}
                <div className="marg-patient-box">
                  <div className="marg-patient-col marg-patient-left">
                    <table>
                      <tbody>
                        <tr>
                          <td width="25%"><strong>Name</strong></td>
                          <td width="5%">:</td>
                          <td><strong style={{ fontSize: '12px', textTransform: 'uppercase' }}>{customer.custName}</strong></td>
                        </tr>
                        <tr>
                          <td><strong>Mobile No.</strong></td>
                          <td>:</td>
                          <td>{customer.mobileNo || "-"}</td>
                        </tr>
                        <tr>
                          <td><strong>Address</strong></td>
                          <td>:</td>
                          <td>{customer.cAddress || "-"}</td>
                        </tr>
                        <tr>
                          <td><strong>Age</strong></td>
                          <td>:</td>
                          <td>{customer.age || "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                 {/* Right Aligned Data */}
                  <div className="marg-patient-col marg-patient-right" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {/* width 50% और marginLeft 50% इसे एकदम राइट में सेट कर देगा */}
                    <table style={{ width: '50%', marginLeft: '50%', whiteSpace: 'nowrap' }}>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: 'left' }}><strong>Receipt No.</strong></td>
                          <td style={{ textAlign: 'center', padding: '0 4px' }}>:</td>
                          <td style={{ textAlign: 'left' }}><strong>{payment.payId}</strong></td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'left' }}><strong>Date</strong></td>
                          <td style={{ textAlign: 'center', padding: '0 4px' }}>:</td>
                          <td style={{ textAlign: 'left' }}>{receiptDateStr}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'left' }}><strong>Time</strong></td>
                          <td style={{ textAlign: 'center', padding: '0 4px' }}>:</td>
                          <td style={{ textAlign: 'left' }}>{receiptTimeStr}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* --- Bill Items Table --- */}
                <div className="marg-table-container">
                  
                  <div className="marg-table-header">
                    <div className="marg-col-sr">S.No.</div>
                    <div className="marg-col-desc">Description / Payment Mode</div>
                    <div className="marg-col-amt">Amount (Rs.)</div>
                  </div>

                  {/* Render Items */}
                  {items.map((item) => (
                    <div className="marg-table-row" key={item.sr}>
                      <div className="marg-col-sr">{item.sr}</div>
                      <div className="marg-col-desc">{item.desc}</div>
                      <div className="marg-col-amt">{item.amount.toFixed(2)}</div>
                    </div>
                  ))}

                  {/* FILLER ROW: Safely extends borders down to the footer */}
                  <div className="marg-table-filler">
                    <div className="marg-col-sr"></div>
                    <div className="marg-col-desc"></div>
                    <div className="marg-col-amt"></div>
                  </div>

                </div>

                {/* --- Summary & Footer --- */}
                <div className="marg-footer-grid">
                  <div className="marg-words-box">
                    <div>
                      <p style={{ margin: "0 0 2px 0", fontSize: "10px" }}><strong>Amount in Words:</strong></p>
                      <p style={{ margin: "0", fontSize: "11px", fontWeight: "bold", textTransform: "capitalize" }}>
                        Rupees {numberToWords(receivedAmount)} Only
                      </p>
                    </div>
                    {payment.remarks && (
                      <div style={{ marginTop: "5px", fontSize: "10px" }}>
                        <strong>Remarks:</strong> {payment.remarks}
                      </div>
                    )}
                    <div style={{ fontSize: "9px", color: "#444", marginTop: "auto" }}>
                      <p style={{ margin: "0" }}><strong>Disclaimer:</strong></p>
                      <ul style={{ paddingLeft: "12px", margin: "2px 0 0 0" }}>
                        <li>This is a computer-generated receipt.</li>
                        <li>Generated By: {payment.recvdby || "System"}</li>
                      </ul>
                    </div>
                  </div>
                  
                  <div className="marg-calc-box">
                    <table className="marg-calc-table">
                      <tbody>
                        <tr className="marg-highlight-row">
                          <td style={{ verticalAlign: 'middle', fontSize: '13px' }}><strong>Total Received</strong></td>
                          <td style={{ textAlign: "right", fontWeight: "bold", fontSize: "15px" }}>₹ {receivedAmount.toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Signatures */}
                <div className="marg-signature-box">
                  <div style={{ textAlign: "center", width: "40%", display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                    <div className="marg-sig-line">Patient / Attendant</div>
                  </div>
                  <div style={{ textAlign: "center", width: "40%", display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                    <div style={{ fontSize: '10px', marginBottom: '2px' }}>{payment.recvdby || "Admin"}</div>
                    <div className="marg-sig-line">Authorized Signature</div>
                  </div>
                </div>

              </div>

            </div>

            {/* --- Action Buttons (Hidden in Print) --- */}
            <div className="no-print d-flex justify-content-end gap-2 mt-2 pt-2 border-top bg-light p-3 rounded-bottom">
              <button 
                  className={`btn btn-sm ${showHeader ? "btn-outline-secondary" : "btn-warning"} fw-medium px-3`} 
                  onClick={handleToggleHeader}
              >
                <i className={`bi ${showHeader ? "bi-eye-slash" : "bi-eye"} me-2`}></i>
                {showHeader ? "Use Letterhead (Hide Header)" : "Show Header"}
              </button>
              <button className="btn btn-secondary btn-sm px-4" onClick={onClose}>Close</button>
              <button className="btn btn-primary btn-sm px-4 fw-bold" onClick={handlePrint} style={{ background: 'var(--theme-color, #0088cc)', borderColor: 'var(--theme-color, #0088cc)' }}>
                  <i className="bi bi-printer me-2"></i> Print
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentReceipt;